
<!-- Login form + it's wrapper -->
@if (authFormsState.showLoginForm && !registrationComplete) {
  <div class="login-section">
    <div id="login" class="h-auto">
      <form >
        <!-- form header -->
        <h2 class="form-header text-start fw-bold font-sans-serif">
          Logga in
        </h2>
        <!-- email input w icon & wrapper -->
        <h2 class="text-header text-start">
          Epostadress
        </h2>
        <div class="input-and-error-wrapper">
          <div class="input-wrapper align-items-center d-flex position-relative">
            <img
              src="../../assets/icons/mail.svg"
              alt=""
              class="input-icon-left"
              />
              <input
                class="input-field w-100 fs-6 font-sans-serif"
            [class.input-field-error]="
              showErrorMessages && (
                (!emailControl.errors?.required && !isEmailValid(loginData.email)) ||
                (emailControl.errors?.required)
              )
            "
                required
                type="email"
                placeholder="Ange din epostadress"
                [(ngModel)]="loginData.email"
                [email]="loginData.email !== ''"
                id="email1"
                aria-describedby="emailHelp"
                name="email"
                autocomplete=""
                #emailControl="ngModel"
                />
              </div>
              @if(showErrorMessages) {
                @if (!emailControl.errors?.required && !isEmailValid(loginData.email)) {
                  <p
                    class="text-danger help-block font-sans-serif fs-6 error-msg error-msg-for-input-field"
                    >
                    <i class="error-msg-icon fas fa-circle-exclamation"></i>
                    Ogiltig e-postadress
                  </p>
                }
                @if (emailControl.errors?.required) {
                  <p
                    class="text-danger help-block font-sans-serif fs-6 error-msg error-msg-for-input-field"
                    >
                    <i class="error-msg-icon"></i>
                    <img alt="" src="../../assets/icons/error.svg"/>
                    Epostadressen är ogiltig.
                  </p>
                }
              }
            </div>
            <!-- pwd input w wrapper & icon -->
            <h2 class="text-header text-start">
              Lösenord
            </h2>
            <div class="input-and-error-wrapper">
              <div class="input-wrapper align-items-center d-flex position-relative">
                <img
                  src="../../assets/icons/lock.svg"
                  alt=""
                  class="input-icon-left"
                  />
                  <input
                    class="input-field w-100 fs-6 font-sans-serif"
                    [class.input-field-error]="showErrorMessages && passwordControl.errors?.required"
                    required
                    [type]="showPassword ? 'text' : 'password'"
                    autocomplete="current-password"
                    id="exampleInputPassword"
                    placeholder="Ange ditt lösenord"
                    [(ngModel)]="loginData.password"
                    name="password"
                    #passwordControl="ngModel"
                    />
                    <i
                      class="fas toggle-password-icon position-absolute fs-6"
                      [class.fa-eye]="!showPassword"
                      [class.fa-eye-slash]="showPassword"
                      role="button"
                      tabindex="0"
                      [attr.aria-label]="showPassword ? 'Dölj lösenord' : 'Visa lösenord'"
                      (click)="togglePasswordVisibility()"
                      (keydown.enter)="togglePasswordVisibility()"
                      (keydown.space)="togglePasswordVisibility()"
                    ></i>
                  </div>
                  @if(showErrorMessages) {
                    @if (passwordControl.errors?.required) {
                      <p
                        class="text-danger help-block font-sans-serif fs-6 error-msg error-msg-for-input-field"
                        >
                        <i class="error-msg-icon "></i>
                        <img alt="" src="../../assets/icons/error.svg"/>
                        Lösenord är ogiltig.
                      </p>
                    }
                  }
                </div>
                <!-- checkbox && glömt lösen -->
                <div class="checkbox-and-forgot-pwd-wrapper p-0 d-flex justify-content-between align-items-center my-3">
                  <div class="form-check align-items-center">
                    <input
                      class="form-check-input fs-4"
                      #KeepMeLoggedIn
                      name="KeepMeLoggedIn"
                      type="checkbox"
                      id="KeepMeLoggedIn"
                      (change)="onRememberMe(KeepMeLoggedIn.checked)"
                      [checked]="loginData.rememberMe"
                      />
                      <label class="font-sans-serif fs-6" for="KeepMeLoggedIn">
                        Håll mig inloggad
                      </label>
                    </div>
                    <a
                      class="font-sans-serif fs-6 m-0 p-0"
                      [routerLink]="['glomtLosenord']"
                      >
                      Glömt lösenord?
                    </a>
                  </div>
                  <!-- Failed login error -->
                  <div class="failed-login-outer-error-wrapper d-flex align-items-center justify-content-center">
                    @if (loginError) {
                      <p class="failed-login-inner-error-wrapper text-danger help-block font-sans-serif fs-6 error-msg">
                        <i class="error-msg-icon"></i>
                        <img alt="" src="../../assets/icons/error.svg" />
                        {{ loginError }}
                      </p>
                    }
                  </div>
                  <!-- Resend button — only shows on 403 unverified error -->
                  @if (loginError && loginError.includes('bekräfta')) {
                    <div class="text-center mt-2">
                      <button class="btn-link fw-bold form-resend-btn font-sans-serif" [disabled]="resendLoading" (click)="resendVerificationEmail()">
                        {{ resendLoading ? 'Skickar...' : 'Skicka verifieringsmejlet igen' }}
                      </button>
                      @if (resendSuccess) {
                        <p class="text-success mt-1">
                          Verifieringsmejlet har skickats!
                        </p>
                      }
                    </div>
                  }
                  <!-- login button -->
                  <button
                    class="btn w-100 text-white fs-4 fw-bold form-submit-btn font-sans-serif"
                    data-bs-target="#login"
                    [attr.data-bs-toggle]="authFormsState.showLoginForm ? '' : 'collapse'"
                    aria-controls="login"
                    aria-expanded="false"
                    aria-label="Toggle login"
        (click)="
          !isEmailValid(this.loginData.email) || !loginData.password
            ? setShowErrorMessages(true)
            : login()
        "
                    >
                    Logga in
                  </button>
                  <div class="font-sans-serif fs-4">
                    Inte medlem?
                    <a class="cursor-pointer m-0 p-0 font-sans-serif fs-4" (click)="showRegisterForm()">
                      Skapa konto
                    </a>
                  </div>
                </form>
              </div>
            </div>
          }

          @if (authFormsState.showLoginForm && registrationComplete) {
            <div class="login-section verification-pending">
              <div class="text-center p-4">
                <h2 class="form-header text-start fw-bold font-sans-serif">Verifiera din e-post</h2>
                <p class="font-sans-serif fs-5 mt-3">
                  Vi har skickat en bekräftelselänk till <strong>{{ registrationEmail }}</strong>.
                </p>
                <p class="font-sans-serif fs-6 text-muted">
                  För att aktivera ditt konto måste du klicka på länken i mejlet. När e-posten är bekräftad kan du logga in.
                </p>
                <div class="d-flex flex-column align-items-center gap-3 mt-4">
                  <button class="btn btn-primary w-100" (click)="backToLogin()">
                    Fortsätt till inloggning
                  </button>
                  <a class="font-sans-serif fs-6" (click)="showRegisterForm()">
                    Gå tillbaka till registrering
                  </a>
                </div>
              </div>
            </div>
          }

          <!-- register comp w event emitters passed down -->
          @if (authFormsState.showRegisterForm) {
            <app-register (userRegistered)="userRegistered($event)" (loadingStateChanged)="setLoadingState($event)"/>
          }
